<template>
  <div id="app">
    <SiteHeader />
    <main>
      <HeroSection />
      <ServicesSection />
      <ProductsSection />
      <ProcessSection />
      <TeamSection />
      <AboutSection />
      <ContactSection />
    </main>
    <SiteFooter />
  </div>
</template>

<script>
import SiteHeader from './components/SiteHeader.vue'
import HeroSection from './components/HeroSection.vue'
import ServicesSection from './components/ServicesSection.vue'
import ProductsSection from './components/ProductsSection.vue'
import ProcessSection from './components/ProcessSection.vue'
import TeamSection from './components/TeamSection.vue'
import AboutSection from './components/AboutSection.vue'
import ContactSection from './components/ContactSection.vue'
import SiteFooter from './components/SiteFooter.vue'

export default {
  name: 'App',
  components: {
    SiteHeader,
    HeroSection,
    ServicesSection,
    ProductsSection,
    ProcessSection,
    TeamSection,
    AboutSection,
    ContactSection,
    SiteFooter
  }
}
</script>
